webpackJsonp([87],{

/***/ 1224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var tableDataSimple = [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016/10/15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016/12/15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016/04/26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016/04/10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016/12/06 14:38:38', 'gender': 'Female' }];

        return {
            tableDataSimple: tableDataSimple,
            isCustom: false
        };
    }
});

/***/ }),

/***/ 1225:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isCustom),
      callback: function($$v) {
        _vm.isCustom = $$v
      },
      expression: "isCustom"
    }
  }, [_vm._v("Custom")])], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.tableDataSimple
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": "ID",
            "width": "40",
            "numeric": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.id) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "First Name"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.first_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Last Name"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.last_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Date",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.gender) + "\n                ")])]
      }
    }])
  }, [(!_vm.isCustom) ? _c('template', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "has-text-right"
  }, [_vm._v("\n                    Footer\n                ")])]) : _c('template', {
    slot: "footer"
  }, [_c('th', {
    staticClass: "is-hidden-mobile",
    staticStyle: {
      "width": "40px"
    }
  }, [_c('div', {
    staticClass: "th-wrap is-numeric"
  }, [_vm._v(" ID ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap"
  }, [_vm._v(" First Name ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap"
  }, [_vm._v(" Last Name ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap is-centered"
  }, [_vm._v(" Date ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap"
  }, [_vm._v(" Gender ")])])])], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1224),
  /* template */
  __webpack_require__(1225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/87.1b92ec0208f6032c8e86.js